import { render, staticRenderFns } from "./RemoveModal.vue?vue&type=template&id=794fa928&scoped=true&"
import script from "./RemoveModal.vue?vue&type=script&lang=js&"
export * from "./RemoveModal.vue?vue&type=script&lang=js&"
import style0 from "./RemoveModal.vue?vue&type=style&index=0&id=794fa928&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794fa928",
  null
  
)

export default component.exports